import { render } from "./page8.vue?vue&type=template&id=1e7cfa0a&scoped=true"
import script from "./page8.vue?vue&type=script&lang=js"
export * from "./page8.vue?vue&type=script&lang=js"

import "./page8.vue?vue&type=style&index=0&id=1e7cfa0a&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e7cfa0a"]])

export default __exports__